import {Controller} from "@hotwired/stimulus"

// A <details> menu closes on neither Escape nor an outside click natively.
export default class extends Controller {
  close(event) {
    if (!this.element.open || this.element.querySelector('dialog[open]')) return
    if (event.type === 'click' && this.element.contains(event.target)) return
    this.element.open = false
    if (event.type === 'keydown') this.element.querySelector('summary').focus()
  }
}
